import { Layout } from "antd";
import SidebarDrawer from "../Sidebar";
import { BrandLogo } from "./BrandLogo";
import { NotificationBell } from "./NotificationBell";
import { UserMenu } from "./UserMenu";
import { useState } from "react";


const { Header: AntHeader } = Layout;

export const Header = ({
  title,
  user,
  onLogout,
  selectedDoctorId,
  onSelectDoctor,
  options
}) => {
  const [openSidebar, setOpenSidebar] = useState(false);

  return (
    <>
      <AntHeader className="w-full flex justify-between items-center h-[80px] px-5 bg-black">
        <BrandLogo title={title} isOpen={openSidebar} onToggle={() => setOpenSidebar(v => !v)} />

        <div className="flex items-center gap-x-5">
          <NotificationBell />
          <UserMenu
            user={user}
            onLogout={onLogout}
            selectedDoctorId={selectedDoctorId}
            onSelectDoctor={onSelectDoctor}
            options={options}
          />
        </div>
      </AntHeader>

      <SidebarDrawer options={options} open={openSidebar} onClose={() => setOpenSidebar(false)} />
    </>
  );
};
